// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__nGAoU","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__KwDmx"};